module.exports = __webpack_public_path__ + "static/media/Done-2.71dc78a2.png";